/**
 * New strings of the "Valider les audios" page, FR and EN. Existing keys of
 * translations.ts stay in use (t.reject, t.rejectionReason, t.audioXofY...).
 */
export const validateAudioCopy = {
  fr: {
    voice: "Voix entendue",
    female: "Femme",
    male: "Homme",
    decisionTitle: "Votre avis",
    accept: "Valider",
    play: "lecture / pause",
    stepAccepted: "Validé",
    stepRejected: "Rejeté",
    sessionTotal: "Validations de la session",
  },
  en: {
    voice: "Voice heard",
    female: "Female",
    male: "Male",
    decisionTitle: "Your decision",
    accept: "Accept",
    play: "play / pause",
    stepAccepted: "Accepted",
    stepRejected: "Rejected",
    sessionTotal: "Session validations",
  },
} as const;

export type ValidateAudioCopy = { [K in keyof (typeof validateAudioCopy)["fr"]]: string };
